import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { QuotationComponent } from '../../quotation/quotation.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-quotation-update-ticket',
  templateUrl: './quotation-update-ticket.component.html',
  styleUrls: ['./quotation-update-ticket.component.scss'],
  standalone: true,
  imports: [TranslateModule],
})
export class QuotationUpdateTicketComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<QuotationComponent>,
    @Inject(MAT_DIALOG_DATA) public quotationId: string,
  ) {}

  ngOnInit(): void {}
}
